import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseService } from 'core/services/firebase.service';
import { LoaderService } from 'core/services/loader.service';
import { RouterService } from 'core/services/router.service';
import { LogoOverlayLoader } from 'shared/components/particles/loaders/logo-overlay-loader/logo-overlay-loader';
import { LANG_CODES, NOTIFICATION_MSG_TYPES, NOTIFICATION_TYPES } from 'shared/enums/common.enum';
import { SITE_ROUTES } from 'shared/enums/routes.enum';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LogoOverlayLoader, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('hq-inventory-admin-panel');

  constructor(
    private translateService: TranslateService,
    public loader: LoaderService,
    private router: Router,
    private firebaseService: FirebaseService,
    private routerService: RouterService
  ) {
    this.resolveTranslation();
  }

  resolveTranslation() {
    this.translateService.setFallbackLang(LANG_CODES.ENGLISH);
    this.translateService.use(LANG_CODES.ENGLISH);
  }

  subscribeRouteChange() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loader.show();
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loader.hide();
      }
    });
  }

  listenNotificationClick() {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', event => {
        if (event?.data?.messageType !== NOTIFICATION_MSG_TYPES.PUSH_RECEIVED) {
          const data = event?.data?.payload?.data ?? event.data?.data ?? event.data;
          const ticketMsgTypes = [
            NOTIFICATION_TYPES.TICKET_MESSAGE
          ]

          if (ticketMsgTypes.includes(data.type)) {
            this.routerService.navigate(SITE_ROUTES.TICKET_CHAT, { id: data.ticketId, source: NOTIFICATION_MSG_TYPES.NOTIFICATION_CLICK })
          }
        }
      });
    }
  }

  ngOnInit(): void {
    this.subscribeRouteChange();
    this.listenNotificationClick();
  }
}
